import { render, staticRenderFns } from "./OrderNumberField.vue?vue&type=template&id=ec71a66c"
import script from "./OrderNumberField.vue?vue&type=script&lang=js"
export * from "./OrderNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports